import { createBreakpoints } from "@chakra-ui/theme-tools"

export const breakpoints = createBreakpoints({
    sm: "20em",    // 320px and above
    md: "48em",    // 768px and above
    lg: "62em",    // 992px and above
    xl: "80em",    // 1280px and above
    "2xl": "96em", // 1536px and above
});

export const colors = {
    white: "#fff",
    black: "#000",
    green: {
        main: "#73C316",
        light: "#9CDE50",
        dark: "#57980B",
        radial: "radial-gradient(70.84% 70.84% at 39.77% 35.37%, #99EC51 0%, #429321 100%)"
    },
    blue: {
        main: "#00466E",
        light: "#0D7AB6",
        dark: "rgba(0, 70, 110, 0.9)",
        radial: "radial-gradient(92.92% 91.44% at 56.95% 35.52%, #0078BB 0%, #003A5B 100%)"
    },
    error: "#EB5757",
    edit: "#F2994A",
    gray: {
        light: 'silver',
        borders: "#888",
        disabledIcon: "#bbb",
        borderBoxes: "#6C6C6C",
        hintText: "rgba(152, 152, 152, 0.75)",
        bgApp: "#eee",
        inactiveText: "rgba(255, 255, 255, 0.75)",
        annonce: "#E3E3E3",
    },
    gradient: "linear-gradient(90deg, #00466E 0%, #1A5E65 18.75%, #8CC63F 100%)"
};
export const effects = {
    boxShadow: {
        items: "2px 2px 20px rgba(0, 0, 0, 0.15)",
        list: "4px 4px 20px rgba(0, 0, 0, 0.25)",
        backgroundBlue: "blur(10px)"
    }   
};
export const font = {
    family: "Open Sans",
    style: "normal",
};